<div
  trackImpression="contentblock-impression"
  trackImpressionName="FAQ"
  [trackImpressionInfo]="rendering()"
>
  @if (content().title; as title) {
    <h2 class="h2 text-center">{{ title }}</h2>
  }
  <div ngbAccordion [animation]="true" [destroyOnHide]="false">
    @for (item of content().faqItems; track item.id) {
      <div [ngbAccordionItem]="item.id" [collapsed]="item.isCollapsed">
        <div ngbAccordionHeader>
          <button
            ngbAccordionButton
            class="accordion-button"
            trackInteraction="click"
            interactionCategory="accordion"
            [interactionData]="item.clickData"
          >
            <span class="accordion-title me-2">{{ item.question }}</span>
          </button>
        </div>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="row answer-padding answer-container">
                @if (item.imageSettings && item.imageSettings.image.src) {
                  <div class="col-md-6">
                    <wl-rich-text-wrapper [field]="{ value: item.answer }">
                      <div></div>
                    </wl-rich-text-wrapper>
                  </div>
                  <div class="col-md-6">
                    <wl-image [imageSettings]="item.imageSettings"></wl-image>
                  </div>
                } @else {
                  <div class="col-12">
                    <wl-rich-text-wrapper
                      [field]="{ value: item.answer }"
                      wlAutomationId="faq-body-richtext"
                    >
                      <div></div>
                    </wl-rich-text-wrapper>
                  </div>
                }
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
</div>
